

import { useRef } from 'react';

import { BlueprintInstanceType, Breakpoint, Vertex2 } from '@rta/rta-blueprint-library';

import { addContextMenu } from '../../context-menu';
import { renderTracking } from '@r-services/render-tracking';
// import { State } from '@r-app/';
import { useDraggableSvg } from '@r-services/ui-interactions';

export type RenderBreakpointParams = {
	// appState: State;
	// appDispatch: React.Dispatch<unknown>;
	breakpoint: Breakpoint;
	center: { x: number, y: number };
	height: number;
};

export const RenderBreakpoint = ({ breakpoint, center, height }: RenderBreakpointParams): React.ReactElement => {
	const movableRef = useRef(null);

	let jsxBreakpoint: React.ReactElement = null;
	const contextMenuBuffer = 0.75;

	const { panel, countertop, backsplash } = breakpoint.refMap;

	// Get size from panel, backsplash, or countertop (in priority order)
	const getSize = () => {
		if (panel?.size) return panel.size;
		if (backsplash?.size) return backsplash.size;
		if (countertop?.size) {
			return {
				width: countertop.size.width,
				height: countertop.size.depth,
				depth: countertop.size.height
			};
		}
		return { width: 0, height: 0, depth: 0 };
	};

	useDraggableSvg({
		ref: movableRef,
		enabled: [true, false],
		cursor: ['inherit', 'move'],
		position: { x: breakpoint.center, y: center.y },
		bBox: {
			origin: new Vertex2({ dataIn: { x: 0, y: 0 }}),
			size: getSize(),
			padding: [0, 0, 0, 0]
		},
		onDragging: (e) => {
			const {
				position: { new: newPosition }
			} = e;
			if (newPosition.x !== breakpoint.center) breakpoint.center = newPosition.x;
			return true;
		},
		onDragEnd: ({ factors }) => {
			console.log('breakpoint:factors', factors.new);
			// breakpoint.center = newPosition.x;
			return true;
		}
	});

	// render panel breakpoints
	jsxBreakpoint = (
		<g ref={movableRef} id="breakpoint" {...addContextMenu({ menuKey: BlueprintInstanceType.Breakpoint, id: breakpoint.id })}>
			<line
				key={breakpoint.id}
				x1={breakpoint.center}
				x2={breakpoint.center}
				y1={center.y - (height / 2)}
				y2={center.y + (height / 2)}
				stroke="red"
				strokeDasharray="2 0.5"
				strokeWidth={0.125}
				{...addContextMenu({ menuKey: BlueprintInstanceType.Breakpoint, id: breakpoint.id })}
				pointerEvents="visible"
			></line>

			{/* Show if Item is Selected */}
			{/* {appState.ui.selected.indexOf(breakpoint.id) !== -1 && (
				<rect
					x={x - 0.06125 - contextMenuBuffer}
					y={y}
					width={0.06125 + (2 * contextMenuBuffer)}
					height={height}
					opacity={0.1}
					strokeWidth="0.125"
					stroke="black"
					fill="lightgreen"
				/>
			)} */}

			{/* rectangle to provide buffer for context menu clicking */}
			<rect
				x={breakpoint.center - 0.06125 - contextMenuBuffer}
				y={center.y - (height / 2)}
				width={0.06125 + (2 * contextMenuBuffer)}
				height={height}
				opacity={0}
				// pointerEvents="none"
				// {...events}
			></rect>
		</g>
	);

	renderTracking.incrementRender('RenderBreakpoint');
	return jsxBreakpoint;
};
